module.exports = __webpack_public_path__ + "static/media/dark_logo_white_background.28f794e2.jpg";